import { APICore } from "./apiCore";

const api = new APICore();

const listarBancos = (query?: string) => {
    return api.get(`/bancos${query ? "?" + query : ""}`);
};

export { listarBancos };
